import { createI18nText } from '@hilma/netina2all';


const whoWeAreText = createI18nText({
    he: {
        title: 'אז מי אנחנו?',
        subtitle: 'אנו, קבוצה של חברים שהחלטנו להקים את הפרויקט כדי לתת לכם את האפשרות לקנות משלוחי מנות ולתרום את כל הרווח לצדקה.',
        subtitleNotice: 'חשוב לציין כי כולנו מתנדבים בעמותה ואיננו מקבלים שכר כלל.',
        footer: <>בנוסף, העמותה מלווה על ידי עורך דין ורואה חשבון:<br /> אברמי וול - עו"ד של העמותה<br /> שטרק את שטרק - רו"ח של העמותה</>,
    },
    en: {
        title: 'Who are we?',
        subtitle: 'We, a group of friends, decided to set up the project to give you the opportunity to buy Mishlochey Manot and donate all the profit to charity.',
        subtitleNotice: ' It is important to note that we all volunteer at the association and profit is not made by the company.',
        footer: <>In addition, the Association has a lawyer and an accountant:<br />
            Abrami Wall - Attorney of the Association<br />
            Stark the Stark - CPA of the Association</>,
    }
});

export default whoWeAreText;